import { render, staticRenderFns } from "./PricingRule.vue?vue&type=template&id=2bb80793&scoped=true"
import script from "./PricingRule.vue?vue&type=script&lang=js"
export * from "./PricingRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb80793",
  null
  
)

export default component.exports